module.exports = __webpack_public_path__ + "img/icon7.c9ba62a6.png";